import React from "react";
import { inject, observer } from "mobx-react";
import ServiceBookingStore from "../ServiceBookingStore";
import classNames from "classnames";
import { XTimeIFrame } from "../components";

interface XTimeServiceBookingProps {}

interface InjectedProps extends XTimeServiceBookingProps {
  serviceBookingStore: ServiceBookingStore;
}

const xTimeServiceBooking: React.FC<XTimeServiceBookingProps> = (props) => {
  const { serviceBookingStore } = props as InjectedProps;

  // hide xTime panel initially
  const xTimePanelStyle = classNames({
    "hide-panel": !serviceBookingStore.gotoNextStep,
  });

  // hide dealer picker panel when user wants to continue
  const firstPanelStyle = classNames({
    "hide-panel": serviceBookingStore.gotoNextStep,
  });

  return (
    <section className="pageSection">
      <div className="pageSection__content">
        <div className="container">
          <div className="serviceRequest">
            <div className="row text-center">
              <div className="col-xs-12 col-md-10 col-lg-10 col-md-offset-1 col-lg-offset-1">
                <h1 className="h1 font-boxx">Book a Service</h1>
                <div
                  className="serviceBookingIntroText"
                  dangerouslySetInnerHTML={{
                    __html: serviceBookingStore.serviceBookingIntroText,
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className={firstPanelStyle}>
                <div className="col-xs-12 col-md-10 col-md-offset-1">
                  <h3 className="h3 text-center">Select retailer</h3>
                  <div
                    id="retailerLocator"
                    data-showRating="false"
                    data-defaultDept="Service"
                    data-size="10"
                  ></div>
                  <p className="text-center selectDealerBtn">
                    <button
                      id="selectDealer"
                      className="btn btn--primary"
                      disabled={!serviceBookingStore.preferredDealerSelected}
                      onClick={() => {
                        serviceBookingStore.setGotoNextStep(true);
                      }}
                    >
                      Select preferred retailer
                    </button>
                  </p>
                </div>
              </div>
              <div className={xTimePanelStyle}>
                <div className="container">
                  <XTimeIFrame
                    isLoading={serviceBookingStore.xTimeIFrameLoading}
                    source={serviceBookingStore.xTimeIFrameSource}
                    className="xtime-iframe"
                    onLoad={() => {
                      if (serviceBookingStore.setxTimeIFrameLoading) {
                        serviceBookingStore.setxTimeIFrameLoading(false);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="formTerms"
            dangerouslySetInnerHTML={{
              __html: serviceBookingStore.serviceBookingTerms,
            }}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default inject("serviceBookingStore")(observer(xTimeServiceBooking));
